import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import IconButton from 'components/v2/IconButton'
import { FilterIcon } from 'components/Icons/FilterIcon'
import { device } from 'utils/style'
import { ResetIcon } from 'components/Icons/ResetIcon'

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FilterWrapper = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;
  grid-template-columns: min-content 1fr min-content;
`

export const FilterButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > * {
    height: fit-content;
  }
`

export const TagsWrapper = styled.div`
  display: flex;
  gap: 8px 16px;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
`

export const FiltersWrapper = styled.div<{ isShowingFilters: boolean; noBorder?: boolean; noPadding?: boolean }>`
  margin-top: 10px;
  display: ${(props): string => (props.isShowingFilters ? 'block' : 'none')};
  border: ${({ noBorder }): string => (noBorder ? '' : '1px solid #e3e3e3')};
  padding: ${({ noPadding }): string => (noPadding ? '' : '24px')};
  background-color: #fff;
`

export const FiltersContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, 100%);

  @media ${device.tablet} {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
`

interface IFilterToggleProps {
  onClick?: () => void
  children?: ReactNode
}

export const FilterToggle = ({ onClick, children }: IFilterToggleProps): ReactElement => {
  return (
    <IconButton onClick={onClick} icon={<FilterIcon />}>
      {children}
    </IconButton>
  )
}

interface IResetButtonProps {
  onClick: () => void
}

export const ResetButton = ({ onClick }: IResetButtonProps): ReactElement => {
  return <IconButton onClick={onClick} icon={<ResetIcon />} />
}

const FiltersSubmitButton = styled.button`
  display: none;
`

export const FiltersSubmit = (): ReactElement => {
  return <FiltersSubmitButton type="submit"></FiltersSubmitButton>
}

export const ApplyButtonWrapper = styled.div`
  justify-self: end;
  display: flex;
  gap: 8px;
`
